import { render, staticRenderFns } from "./Watermark.vue?vue&type=template&id=83d9a18c&"
import script from "./Watermark.vue?vue&type=script&lang=js&"
export * from "./Watermark.vue?vue&type=script&lang=js&"
import style0 from "./Watermark.vue?vue&type=style&index=0&id=83d9a18c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports